















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["accountBook"])
})
export default class ChooseSubject extends Vue {
    // 多栏账的科目
    @Prop({ type: Array })
    subList!: Subject.Subject[];
    // 判断是否是多栏账的get接口
    @Prop({ type: Boolean, default: false })
    isGet?: boolean;
    // 判断是否是多栏账的辅助核算科目
    @Prop({ type: Boolean, default: false })
    isAssist?: boolean;
    // 用户判断是否有其他科目的api接口
    @Prop({ type: String })
    api?: string;

    @Prop({ type: String })
    currentAccountTypeName?: string;

    @Prop({ type: Boolean })
    isBalance?: boolean;

    @Prop({ type: Boolean })
    isSecond?: boolean;

    @Prop({ type: Boolean })
    isfirst?: boolean;

    @Prop({ type: [Object, String] })
    model?: Subject.Subject | Assist.AssistAccount | null;

    @Prop({ type: Object })
    rowSubject?: Subject.Subject;

    @Prop({ type: Boolean, default: false })
    hideNo!: boolean;

    @Prop({ type: String, default: "text" })
    valueKey?: string;

    subject: any = [];

    subjectList: Subject.Subject[] = []; //科目
    subjectVal: Subject.Subject | string | null = null; //初始科目

    subIndex: number = 0;
    noPre: boolean = false;
    noNext: boolean = false;

    assistAll = {
        id: null,
        no: "",
        text: "全部",
        dimAccountTypes: [],
        dimAccountType: null,
        measuringUnit: null,
        currSymbol: null
    };

    mounted() {
        if (!this.isGet) this.getSubjects();
        else {
            this.subjectList = this.subList;
            this.subjectVal = this.subjectList[0];
            this.subIndexChange(0);
        }
    }

    // 监听科目切换
    @Watch("subIndex")
    subIndexChange(val: number) {
        let list = this.subjectList;
        if (list.length > 0) {
            if (val === 0) {
                this.noPre = true;
                this.noNext = false;
            } else if (val === list.length - 1) {
                this.noNext = true;
                this.noPre = false;
            } else {
                this.noPre = false;
                this.noNext = false;
            }
        } else {
            this.noPre = true;
            this.noNext = true;
        }
    }

    @Watch("subjectVal")
    subjectChange(val: Subject.Subject | string) {
        this.$emit("update:model", val);
        this.$emit("change", val);
    }

    @Watch("model")
    modelChange(val: Subject.Subject | string) {
        // this.$emit("change", val);
        this.subjectVal = val;
    }

    @Watch("subList", { deep: true })
    listChange(val: Subject.Subject[]) {
        if (this.isGet) {
            this.subjectList = val;
            this.subjectVal = this.subjectList[0];
            this.subIndexChange(0);
        }
    }

    // 获取科目或辅助选项列表
    getSubjects(then?: Function) {
        let url: string;
        if (this.api) url = this.api;
        else url = `subjects/findall`;
        Vue.axios
            .post(url, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                if (!this.api) {
                    this.subjectList = res.data.subjects;
                    this.subjectVal = res.data.subjects[0];
                    this.subIndexChange(0);
                    this.$emit("getList", this.subjectList);
                } else if (url.includes("findass")) {
                    // 辅助核算期初
                    if (this.rowSubject) {
                        this.subjectList = res.data;
                        for (var i = 0; i < this.subjectList.length; i++) {
                            if (this.subjectList[i].text == this.rowSubject.text) {
                                this.subIndex = i;
                                break;
                            }
                        }
                        this.subjectVal = this.rowSubject;
                        this.subIndexChange(this.subIndex);
                    } else {
                        this.subjectList = res.data;
                        this.subjectVal = this.subjectList[0];
                        this.subIndexChange(0);
                    }
                }
                else {
                    // 所有辅助项的科目及辅助核算hashmap
                    this.subject = res.data.subjects;
                    // 默认使用项目的list
                    this.subjectList = this.subject.dimItemList;
                    if (this.currentAccountTypeName) {
                        let val = this.currentAccountTypeName
                        this.navChange(val)
                    }
                    this.changeInit(this.assistType);
                    this.subIndexChange(0);
                    this.$emit("update:model", this.subjectVal);
                    if (then) then();
                }
            });
    }
    // 监听currentAccountTypeName
    assistType: string = "";
    @Watch("currentAccountTypeName")
    navChange(val: string) {
        this.subIndex = 0;
        switch (val) {
            case "项目":
                this.changeInit("dimItemList");
                break;
            case "客户":
                this.changeInit("dimCustomerList");
                break;
            case "供应商":
                this.changeInit("dimProviderList");
                break;
            case "部门":
                this.changeInit("dimDepartmentList");
                break;
            case "员工":
                this.changeInit("dimEmployeeList");
                break;
            case "存货":
                this.changeInit("dimInventoryList");
                break;
        }
    }

    // 若科目列表不为空，添加全部项
    changeInit(val: string) {
        this.assistType = val;
        this.subjectList = this.subject[val];
        if (this.subjectList.length > 0) {
            if (this.subjectList[0].text != "全部") {
                this.subjectList.unshift(this.assistAll);
                this.subjectVal = this.subjectList[0];
            } else {
                this.subjectVal = this.subjectList[0];
            }
        } else {
            this.subjectVal = null;
        }
        this.subIndexChange(0);
        this.$emit("update:model", this.subjectVal);
        this.$emit("change", this.subjectVal);
    }

    // 选择科目
    changeSubject(val: Subject.Subject) {
        for (var i = 0; i < this.subjectList.length; i++) {
            if (this.subjectList[i] == val) {
                this.subIndex = i;
                break;
            }
        }
    }

    // 上一个科目
    preSub() {
        if (this.subIndex != 0) {
            this.subIndex--;
            this.subjectVal = this.subjectList[this.subIndex];
        }
    }
    // 下个科目
    nextSub() {
        let list = this.subjectList;
        if (list.length > 0) {
            if (this.subIndex != list.length - 1) {
                this.subIndex++;
                this.subjectVal = this.subjectList[this.subIndex];
            }
        }
    }
}
